<div class="modal-header">
    <h6 class="modal-title medium">{{'scheduleAnnouncement' | translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body">
    <h6>{{'selectActivationDateTime' | translate}}</h6>
    <div class="row d-flex align-items-center">
        <div class="col-lg-6 col-md-6">
            <input class="form-control" placeholder="YYYY-MM-DD" name="startDate" [minDate]="minStartDate"
                   [(ngModel)]="announcementData.activationDate"
                   ngbDatepicker #startDate="ngbDatepicker" required readonly>
            <button class="iga-right" (click)="startDate.toggle(); openDatePicker(startDate)" type="button">
                <i class="fa fa-calendar"></i>
            </button>
        </div>
        <div class="col-lg-6 col-md-6 pl-5">
            <ngb-timepicker [(ngModel)]="activationTime" [meridian]="meridian"></ngb-timepicker>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')"> {{'cancel' |
        translate}}
    </button>
    <button class="btn btn-primary float-right" [disabled]="buttonStatus" (click)="schedule()"> {{'confirm' |
        translate}}
    </button>
</div>


// WEBPACK FOOTER //
// ./src/app/programManagement/announcements/scheduleAnnouncement.html